import QuestionLabel from './QuestionLabel';
import SafeHtml from '../../SafeHtml.jsx';

const DisplayTextQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />

            <div className="display-text-question">
                <SafeHtml html={settings?.display} />
            </div>
        </label>
    );
};

export default DisplayTextQuestion;
